import { HStack, VStack, Text } from '@genial/components';
import React from 'react';

export interface ValueWithSubtitleProps {
  value: string;
  valueDescription?: string;
  subtitle?: string;
  subtitleDescription?: string;
}

export const ValueWithSubtitle: React.FC<ValueWithSubtitleProps> = ({
  value,
  valueDescription,
  subtitle,
  subtitleDescription,
}) => {
  return (
    <VStack>
      <HStack space="inline.quarck" alignItems="flex-end">
        <Text>{value}</Text>
        {valueDescription && (
          <Text color="neutral.dark" fontSize="xs">
            {valueDescription}
          </Text>
        )}
      </HStack>
      {subtitle && (
        <HStack space="inline.quarck" alignItems="flex-end">
          <Text color="neutral.dark" fontSize="xs">
            {subtitle}
          </Text>
          {subtitleDescription && (
            <Text color="neutral.dark" fontSize="xs">
              {subtitleDescription}
            </Text>
          )}
        </HStack>
      )}
    </VStack>
  );
};
